import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import VehicleForm from './VehicleForm'

function Vehicle(props) {
    const { isVehicleModalOpen, setIsVehicleModalOpen, notify, isInTransient } = props
    const handleClose = () => {
        setIsVehicleModalOpen(false)
    }
    return (
        <>
            <Modal className='compmodal' show={isVehicleModalOpen} onHide={() => setIsVehicleModalOpen()} centered>
                <Modal.Header className='text-primary'><i className='fa fa-angle-left me-2 text-primary' onClick={() => handleClose()}></i><span className='w-100 text-center'>Add New Vehicle</span></Modal.Header>
                <Modal.Body>
                    <VehicleForm setIsVehicleModalOpen={setIsVehicleModalOpen} notify={notify} isInTransient={isInTransient} />
                </Modal.Body>
            </Modal>
        </>
    )
}

Vehicle.propTypes = {
    dispatch: PropTypes.func,
    isVehicleModalOpen: PropTypes.bool,
    setIsVehicleModalOpen: PropTypes.func,
    finalAction: PropTypes.func,
    notify: PropTypes.func,
    isInTransient: PropTypes.bool
}

Vehicle.defaulProps = {
    dispatch: noop,
    isVehicleModalOpen: false,
    setIsVehicleModalOpen: noop,
    finalAction: noop,
    notify: noop,
    isInTransient: false
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(Vehicle)